<div class="search-container">
  <form class="form-search-bar" [formGroup]="searchForm" (ngSubmit)="handleSubmit()">

    <mat-form-field appearance="outline">
      <mat-label>Response Type</mat-label>
      <mat-select [formControl]="responseTypeControl">
        <mat-option *ngFor="let type of responseType" [value]="type.value">{{type.description}}</mat-option>
      </mat-select>
    </mat-form-field>

    <button type="button" mat-raised-button (click)="clean()">Clean</button>
    <button type="submit" mat-raised-button color="primary">Apply</button>
    <app-zoom-help></app-zoom-help>
    <app-new-tab-button></app-new-tab-button>

  </form>
</div>
